import { Box, Button, FormControl, TextField, Typography, Checkbox, FormControlLabel, IconButton, InputAdornment } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Alert } from '@mui/material';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';  // Import Firebase auth and firestore
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
function RegisterForm() {
    const [checked, setChecked] = useState(false);
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    const handleRegister = async (e) => {
        e.preventDefault();  // Empêche la soumission par défaut du formulaire
        if (!checked) return; // Assure que les conditions sont acceptées

        try {
            // Crée un nouvel utilisateur avec Firebase Authentication
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // Sauvegarde les données de l'utilisateur dans Firestore
            await setDoc(doc(db, 'users', user.uid), {
                bannerProfileURL: '',
                username: username,
                email: user.email,
                userId: user.uid,
                favoriteKdramas: [],
                inProgressKdramas: [],
                profileImageURL: '',
                watchedKdramas: [],
                toWatchKdramas: [],
            });

            // Ouvrir le snackbar après le succès de l'inscription
            setOpenSnackbar(true);

            // Redirection après 3 secondes
            setTimeout(() => {
                navigate('/login');
            }, 3000);

        } catch (error) {
            console.error("Erreur lors de l'inscription :", error);
            alert("Échec de l'inscription. Veuillez réessayer.");
        }
    };

    const navToLogin = () => {
        navigate('/login');
    };
    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev); // Bascule la visibilité du mot de passe
    };
    return (
        <>
            <Box sx={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#121212',
                padding: '2rem'
            }}>
                <Typography sx={{ fontFamily: 'SUSE, sans-serif', color: 'white', mb: 4 }} variant="h4">Créer un compte</Typography>

                {/* Ajout de onSubmit pour la gestion du formulaire */}
                <form onSubmit={handleRegister}>
                    <FormControl sx={{
                        backgroundColor: '#1e1e1e',
                        padding: '2rem',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                        width: '100%',
                        maxWidth: '400px'
                    }}>
                        <TextField
                            sx={{
                                mt: 2,
                                '& .MuiInputBase-root': { color: 'white' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#555'
                                },
                                '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#888'
                                },
                                '& .MuiInputLabel-root': { color: '#aaa' },
                            }}
                            InputLabelProps={{ style: { color: 'white', fontFamily: 'SUSE, sans-serif' } }}
                            type="email"
                            id="outlined-basic"
                            label="Email"
                            required
                            variant="outlined"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <TextField
                            sx={{
                                mt: 2,
                                '& .MuiInputBase-root': { color: 'white' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#555'
                                },
                                '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#888'
                                },
                                '& .MuiInputLabel-root': { color: '#aaa' },
                            }}
                            InputLabelProps={{ style: { color: 'white', fontFamily: 'SUSE, sans-serif' } }}
                            type="text"
                            id="outlined-basic"
                            label="Nom d'utilisateur"
                            required
                            variant="outlined"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />

                        <TextField
                            sx={{
                                mt: 2,
                                '& .MuiInputBase-root': { color: 'white' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#555'
                                },
                                '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#888'
                                },
                                '& .MuiInputLabel-root': { color: '#aaa' },
                            }}
                            InputLabelProps={{ style: { color: 'white', fontFamily: 'SUSE, sans-serif' } }}
                            id="outlined-basic"
                            label="Mot de passe"
                            required
                            variant="outlined"
                            value={password}
                            type={showPassword ? "text" : "password"}
                            onChange={(e) => setPassword(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={togglePasswordVisibility}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff sx={{ color: 'white' }} /> : <Visibility sx={{ color: 'white' }} />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />

                        <FormControlLabel
                            control={<Checkbox sx={{ color: 'white' }} checked={checked} onChange={handleChange} />}
                            label={<Typography sx={{ color: 'white', fontFamily: 'SUSE, sans-serif' }}>J'accepte les conditions d'utilisation</Typography>}
                            sx={{ mt: 2 }}
                        />

                        <Button
                            sx={{
                                mt: 3,
                                fontFamily: 'SUSE, sans-serif',
                                color: 'white',
                                backgroundColor: checked ? 'primary.main' : 'rgba(255, 255, 255, 0.12)',
                                '&.Mui-disabled': {
                                    color: 'white',
                                    backgroundColor: 'rgba(255, 255, 255, 0.12)'
                                },
                                '&:hover': {
                                    backgroundColor: checked ? 'primary.dark' : 'rgba(255, 255, 255, 0.12)',
                                }
                            }}
                            type="submit"
                            variant="contained"
                            disabled={!checked}
                        >
                            S'inscrire
                        </Button>

                        <Typography sx={{ color: 'white', fontFamily: 'SUSE, sans-serif', mt: 2 }} variant="body2">
                            Vous avez déjà un compte ? <span onClick={navToLogin} style={{ color: '#1976d2', cursor: 'pointer' }}>Se connecter</span>
                        </Typography>
                    </FormControl>
                </form>

                <Typography sx={{ color: 'white', fontFamily: 'SUSE, sans-serif', mt: 4 }} variant="body2" textAlign="center">
                    En vous inscrivant, vous pourrez enregistrer vos K-Dramas préférés dans une liste et gérer facilement les séries que vous avez déjà vues ou que vous souhaitez découvrir.
                </Typography>
                <Typography sx={{ color: 'white', fontFamily: 'SUSE, sans-serif', mt: 2 }} variant="body2" textAlign="center">
                    C'est gratuit, et de nouvelles fonctionnalités seront ajoutées prochainement !
                </Typography>
            </Box>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="success">
                    Inscription réussie ! Vous serez redirigé vers la page de connexion.
                </Alert>
            </Snackbar>
        </>
    );
}

export default RegisterForm;
